module.exports = __webpack_public_path__ + "static/media/phone-solid.fbdf6146.svg";